<template>
  <v-app class="mb-0">
    <TutorialCss />
    <v-overlay :value="overlay.flag" opacity="0.6" z-index="1500">
      <p style="font-size: 3em">{{ overlay.msg }}</p>
    </v-overlay>
    <MenuPage @controlDrawer="controlDrawer"/>
    <SideMenu :drawer="drawer"/>
    <v-main>
      <div>
        <v-fade-transition mode="out-in">
          <router-view/>
        </v-fade-transition>
      </div>
    </v-main>
    <v-snackbar v-model="snackbar.flag" :timeout="snackbar.timeout" light top right outlined :color="snackbar.color">
      {{ snackbar.msg }}
    </v-snackbar>
  </v-app>
</template>

<script>
import MenuPage from "@/components/home/HeaderMenu";
import SideMenu from "./components/home/SideMenu"
import firebaseMixin from "@/mixins/mixin.js"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import TutorialCss from "./components/tutorial/TutorialCss.vue";

export default {
  name: 'App',
  mixins: [firebaseMixin],
  methods: {
    controlDrawer(flag) {
      this.drawer = flag
    }
  },
  computed: {
    snackbar() {
      return this.$store.getters["state/storeSnackbar"]
    },
    overlay() {
      return this.$store.getters["state/storeOverlay"]
    }
  },
  watch: {
    snackbar() {
      return this.snackbar
    },
    deep: true
  },
  data: () => ({
    drawer: false,
    load: false
  }),
  components: {
    MenuPage,
    SideMenu,
    TutorialCss
  },
  async created() {
    const auth = getAuth()
    onAuthStateChanged(auth, async (user) => {
      if (!user) {
        // console.log("未ログイン")
        return
      }
      const uid = user.uid
      // console.log("ログインUID:", uid)

            
      const counterData = await this.getDocument(["counter", uid])
      // console.log("取得カウンターデータ:", counterData)

      if (this.isFirstLoginThisMonth(counterData)) {
        await this.resetMonthlyCounters(uid, counterData)
        // console.log("月初リセット実行:", uid)
      } else {
        // console.log("今月はすでにリセット済み")
      }
  })
}
}
</script>
<style lang="css">
.v-data-table td {
   white-space : nowrap;
}

.shepherd-modal-overlay-container {
  z-index: 3000 !important;
}
.shepherd-element {
  z-index: 3100 !important;
}
</style>
